/* istanbul ignore file */
import unionBy from 'lodash/unionBy';

import { success } from '@lumapps/notifications';

import {
    getAllSocialNetworkCapabilities as getAllSocialNetworkCapabilitiesApiCall,
    fetchSocialNetworksSettings as getAllSocialNetworkConfigurationsApiCall,
    getSocialNetworkData as getSocialNetworkDataApiCall,
    updateSocialNetworkData as updateSocialNetworkDataApiCall,
} from '../api';
import { SOCIAL_NETWORKS } from '../keys';

const DOMAIN = 'SA/SOCIAL_NETWORKS';

const GET_ALL_SOCIAL_NETWORKS = `${DOMAIN}/GET_ALL_SOCIAL_NETWORKS`;

const UPDATE_SOCIAL_NETWORK = `${DOMAIN}/UPDATE_SOCIAL_NETWORK`;

const SET_FACEBOOK_SDK_READY = `${DOMAIN}/SET_FACEBOOK_SDK_READY`;

const getAllSocialNetworks = () => (dispatch) => {
    Promise.all([getAllSocialNetworkConfigurationsApiCall(), getAllSocialNetworkCapabilitiesApiCall()]).then(
        (result) => {
            const [{ data: socialNetworks }, { data: capabilities }] = result;

            dispatch({
                socialNetworks: unionBy(socialNetworks || [], capabilities || [], 'socialNetworkId'),
                type: GET_ALL_SOCIAL_NETWORKS,
            });
        },
    );
};

const getSocialNetworkData = (id) => (dispatch) => {
    getSocialNetworkDataApiCall(id).then(({ data }) => {
        dispatch({
            socialNetwork: { socialNetworkId: id, ...data },
            type: UPDATE_SOCIAL_NETWORK,
        });
    });
};

const activateSocialNetwork = (id) => (dispatch) => {
    updateSocialNetworkDataApiCall(id, true, false).then(({ data }) => {
        dispatch({
            socialNetwork: { socialNetworkId: id, ...data },
            type: UPDATE_SOCIAL_NETWORK,
        });

        dispatch(
            success({
                translate: {
                    key: SOCIAL_NETWORKS.ACTIVATION_SUCCESS,
                    replacements: {
                        PLATFORM: id,
                    },
                },
            }),
        );
    });
};

const deactivateSocialNetwork = (id) => (dispatch) => {
    updateSocialNetworkDataApiCall(id, false, false).then(({ data }) => {
        dispatch({
            socialNetwork: { socialNetworkId: id, ...data },
            type: UPDATE_SOCIAL_NETWORK,
        });

        dispatch(
            success({
                translate: {
                    key: SOCIAL_NETWORKS.DEACTIVATION_SUCCESS,
                    replacements: {
                        PLATFORM: id,
                    },
                },
            }),
        );
    });
};

export {
    getAllSocialNetworks,
    getSocialNetworkData,
    activateSocialNetwork,
    deactivateSocialNetwork,
    GET_ALL_SOCIAL_NETWORKS,
    UPDATE_SOCIAL_NETWORK,
    SET_FACEBOOK_SDK_READY,
};
